import React, { Fragment, useEffect, useMemo, useState } from "react";
import { COLLAB_KEY, INITIAL_GET_PARAMS, SPECIAL_POPULAR_TAGS } from "../../../enums/generalEnums";
import { getPinnedUsers } from "../../../config/apisauce";
import { arrayRandomizer } from "../../../helpers/arrayHelper";
import { router } from "@inertiajs/react";
import useStore from "../../../states/store";
import { TagsSection } from "./TagsSection";
import { GenericNoData } from "../../../components/generic/GenericNoData";
import { UsersFour } from "@phosphor-icons/react";
import { Typography } from "@mui/material";
import { capitalizeFirstLetter } from "../../../helpers/stringHelper";

const TopCreators = () => {
  const [, { setPopularTag, setCreatorFilters, openLoader, closeLoader, setUserIds }] = useStore();
  const [tags, setTags] = useState([]);

  const fetchTags = async () => {
    openLoader();
    const params = {
      ...INITIAL_GET_PARAMS,
    };
    const response = await getPinnedUsers(params);
    if (response.ok) {
      setTags(response?.data?.data);
    }
    closeLoader();
  };

  const renderTags = useMemo(() => {
    const currentList = [...tags];
    const filterList = currentList
      ?.filter((item) => item?.user_ids?.length > 0)
      ?.map((item) => ({
        ...item,
        order: item?.meta?.order ?? 99,
        user_ids: arrayRandomizer(item.user_ids, item?.name === COLLAB_KEY ? null : 8)
      }))
      ?.sort((a, b) => a.order - b.order);
    return filterList;
  }, [tags]);

  const handleViewAllBasedOnTag = (key, userIds) => {
    router.visit('/collab-creators');
    if (SPECIAL_POPULAR_TAGS?.TAGS?.includes(capitalizeFirstLetter(key))) {
      const filterTag = SPECIAL_POPULAR_TAGS?.[key];
      setCreatorFilters(filterTag);
    } else {
      setCreatorFilters(key !== COLLAB_KEY ? { category_values: key } : {});
    }

    if (key === COLLAB_KEY) {
      setUserIds(userIds);
    } else {
      setUserIds([]);
    }

    setPopularTag(key);
  };

  useEffect(() => {
    fetchTags();
  }, []);

  return (
    <Fragment>
      {
        renderTags?.length > 0 ? renderTags?.map((tag, index) => {
          return (
            <TagsSection
              key={`tag-key-${index}`}
              tag={tag}
              handleViewAll={() => handleViewAllBasedOnTag(tag?.name, tag?.user_ids)}
              lazyLoad={index > 0}
            />
          );
        }) : <GenericNoData
          size={'128px'}
          icon={<UsersFour size={60} />}
          customLabel={
            <Fragment>
              <Typography variant={'h5'} fontWeight={700}>No creators found</Typography>
              <Typography color="grey.dark">Be the first to sign up, it&apos;s free!</Typography>
            </Fragment>
          }
          height={'50vh'}
        />
      }
    </Fragment>
  );
};

export default TopCreators;